'use client';

import { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export function SupportChatButton() {
	const [unread, setUnread] = useState(0);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const handleUnread = (count: number) => setUnread(count);
		const handleOpen = () => setOpen(true);
		const handleClose = () => setOpen(false);

		const interval = setInterval(() => {
			if (typeof window !== 'undefined' && (window as any).Tawk_API) {
				const api = (window as any).Tawk_API;
				api.onUnreadCountUpdate = handleUnread;
				api.onChatMaximized = handleOpen;
				api.onChatMinimized = handleClose;
				api.onChatHidden = handleClose;
				clearInterval(interval);
			}
		}, 500);

		return () => {
			clearInterval(interval);
			if (typeof window !== 'undefined' && (window as any).Tawk_API) {
				const api = (window as any).Tawk_API;
				api.onUnreadCountUpdate = null;
				api.onChatMaximized = null;
				api.onChatMinimized = null;
				api.onChatHidden = null;
			}
		};
	}, []);

	const toggleChat = () => {
		if (typeof window === 'undefined' || !(window as any).Tawk_API) return;
		const api = (window as any).Tawk_API;
		if (open) {
			api.hideWidget?.();
		} else {
			api.toggle?.();
		}
	};

	return (
		<Button variant="outline" onClick={toggleChat} className="relative">
			<MessageCircle className="h-4 w-4" />
			Suporte
			{unread > 0 && (
				<Badge className="absolute -right-1 -top-1 h-4 min-w-4 p-0 leading-none">
					{unread}
				</Badge>
			)}
		</Button>
	);
}
